module.exports = __webpack_public_path__ + "media/Icons/ConfirmedIcon-c057ead9.png";